<template>
	<button class="flex flex-none font-medium items-center justify-center gap-[8px] leading-7 w-fit h-fit py-1.5 px-4 text-secondary-900 text-base bg-secondary-500 rounded hover:shadow-button hover:bg-secondary-200 focus:bg-secondary-100 focus:shadow-none active:bg-secondary-100 active:shadow-none disabled:bg-grays-400 disabled:shadow-none disabled:text-grays-600"> 
		הזמן עוד 
		<span class="flex items-center rounded-full h-[18px] w-[18px] text-[10px] leading-[18px] bg-secondary-900 text-white p-[6px]">{{productQuantity}}</span>
	</button>
</template>

<script>
export default {
	name: "button-order-more",
	props: {
		productQuantity: {
			type: Number,
			default: 1,
		}
	}
}
</script>

<style>

</style>